import React, { useEffect, useContext } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Header from "../../component/Header";
import API from "../../helper/API";
import { AppContext } from "../../context/app-context";

const RiskAssessment = () => {

    const [state, dispatch] = useContext(AppContext);
    const [searchParams] = useSearchParams();
    let navigate = useNavigate();

    const token = searchParams.get("token");
    const country = searchParams.get("country");
    localStorage.setItem('country', country);
    
    const userAppInfo = {
        appVersion: searchParams.get("appVersion"),
        appVersionCode: searchParams.get("appVersionCode"),
        osType: searchParams.get("osType"),
        isGoalSet: searchParams.get("isGoalSet"),
        token: token
    }
    
    if(token)
        localStorage.setItem('token', token);

    useEffect(() => {
        API.get('/user/basic-info').then(userRes => {
        if(userRes?.data?.id) {
            dispatch({
                type: "USER_DETAILS",
                payload: { ...userRes.data, ...userAppInfo}
            });
            
            API.get(`/user/risk-assessments?userId=${userRes.data.id}&active=true`).then(riskRes => {
            if(riskRes.data.length > 0){
                const data = riskRes.data[0];
                let queData = {};
                data.questionerResponse.forEach(element => {
                    if(element.questionerLabel === 'gestational_diabetes')
                        queData = {...queData, ...{gestationalDiabetes: element.responseText}}
                    else if(element.questionerLabel === 'family_diabieties_history')
                        queData = {...queData, ...{diabetes: element.responseText}}
                    else if(element.questionerLabel === 'high_blood_pressure')
                        queData = {...queData, ...{bloodPressure: element.responseText}}
                    else if(element.questionerLabel === 'physically_active')
                        queData = {...queData, ...{physicallyActive: element.responseText}}
                });
                queData = { ...queData, ...{preRiskAssessment : data, bmi: data.userInfo} }
                dispatch({
                    type: "RISK_ASSESSMENT",
                    payload: queData
                });
                navigate('/riskAssessment/list');
            }else {
                navigate('question/userDetails');
            }
            })
        }
        })

    },[]);

    return( <Header title="Risk Assessment" /> )
}

export default RiskAssessment